import React from "react";
import MetricCard from "./MetricCard";
import SectionPanel from "./SectionPanel";
import { COLORS } from "../mockData";

const formatRows = (rows = []) =>
  rows.map((r) => ({
    label: r.label,
    value:
      r.percentage !== undefined ? `${r.value} (${r.percentage}%)` : r.value,
  }));

const MedianTimeToRemission = ({ data, loading, onCardClick }) => {
  const section = data?.medianTimeToRemission;
  const cards = section?.cards || [];

  if (!cards.length && !loading) return null;

  return (
    <SectionPanel title={section?.title || "Median Time to Remission"}>
      <div className="analytics-card-pair">
        {cards.map((card, i) => (
          <MetricCard
            key={i}
            label={card.label}
            period={card.timeRange}
            mainValue={card.displayValue}
            accentColor={card.label === "PHQ-9" ? COLORS.phq9 : COLORS.gad7}
            labelColor={
              card.label === "PHQ-9" ? COLORS.phq9Label : COLORS.gad7Label
            }
            rows={formatRows(card.rows)}
            onClick={
              onCardClick
                ? () =>
                    onCardClick({
                      cardType: "medianTimeToRemission",
                      assessmentType: card.label === "PHQ-9" ? "phq9" : "gad7",
                      timeRange: card.timeRange,
                      sectionTitle: section?.title || "Median Time to Remission",
                      cardLabel: card.label,
                    })
                : undefined
            }
          />
        ))}
      </div>
    </SectionPanel>
  );
};

export default MedianTimeToRemission;
